import _ from 'lodash';

export default {
    data: () => ({
        loading: false,
        page: 1,
        pageCount: 1,
        filter: {},
        query: null,
    }),
    computed: {
        itemIndex() {
            return (index) => (this.page - 1) * 10 + index;
        },
    },
    methods: {
        changeFilter() {
            this.sync();
            this.page = 1;
        },
        async sync() {
            try {
                this.loading = true;
                await this.fetch({
                    page: this.page,
                    filter: this.filter,
                    query: this.query,
                    ...this.operationParams,
                });
            } catch (e) {
                this.$showApiError(e);
            } finally {
                this.loading = false;
            }
        },
        async handleCreate(data) {
            await this.create({ ...data, ...this.operationParams });
            this.sync();
        },
        async handleUpdate(data) {
            await this.update({ ...data, ...this.operationParams });
            this.sync();
        },
        showUpdateDialog(data) {
            this.$refs.createDialog.showUpdateDialog(data);
        },
        async showDeleteDialog(data) {
            this.$refs.confirmDialog.show(data);
        },
        async handleDelete(data) {
            await this.delete(data);
            this.sync();
            this.$showHint('刪除成功');
        },
        async handleMove(item, direction) {
            const { data } = await this.move({ id: item.id, direction });
            if (data.movement > 0) {
                this.sync();
            }
        },
    },
    created() {
        _.attempt(this.init);
        this.sync();
    },
};
